import "core-js/modules/es6.object.assign";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { getmodule_api } from "@/api/auth";
export default {
  name: "interFaceConfig",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      personMenuData: [],
      reqBase: {
        page: 1,
        page_size: 100
      },
      spinShow: false,
      interConfit: [],
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      formModel: {
        parent_id: null,
        menu_name: null,
        route: null,
        menu_desc: null,
        api_codes: []
      },
      formRules: {
        menu_name: [{
          required: true,
          message: '请输入页面名称',
          trigger: 'blur'
        }],
        route: [{
          required: true,
          message: '请输入路径',
          trigger: 'blur'
        }],
        menu_desc: [{
          required: true,
          message: '请输入页面说明',
          trigger: 'change'
        }],
        api_codes: [{
          required: true,
          type: 'array',
          message: '请选择接口配置',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {},
    personMenu: {}
  },
  components: {},
  computed: {},
  methods: {
    checkChange: function checkChange(checkData) {
      var arr = [];

      for (var i in checkData) {
        var list = checkData[i];

        if (list.nodeKey !== 0) {
          arr.push(list.api_code);
        }
      }

      this.$set(this.formModel, 'api_codes', arr);
    },
    initInterface: function initInterface() {
      var _this = this;

      this.spinShow = true;
      getmodule_api({}).then(function (res) {
        _this.spinShow = false;

        if (res.result === 0) {
          var getArr = [];
          var arr = res.body || [];

          for (var i in arr) {
            var list = arr[i];

            var obj = _objectSpread({
              title: list.mod_name
            }, list, {
              expand: true,
              children: []
            });

            for (var j in list.apilist) {
              var item = list.apilist[j];

              var childObj = _objectSpread({
                title: item.res_desc,
                expand: true
              }, item);

              if (_this.formModel.api_codes.indexOf(item.api_code) > -1) {
                childObj.checked = true;
              }

              obj.children.push(childObj);
            }

            getArr.push(obj);
          }

          _this.interConfit = getArr;
        } else {
          _this.interConfit = [];
        }
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    if (this.edit) {
      Object.assign(this.formModel, this.setData);
    }

    this.initInterface();
  }
};